// Little Lamb design form: live preview, conditional "something different" fields.
(function () {
  function init(root) {
    if (root.dataset.llReady) return;
    root.dataset.llReady = '1';
    var input = root.querySelector('[data-ll-input]');
    var preview = root.querySelector('[data-ll-preview]');
    var badge = root.querySelector('[data-ll-badge]');
    var sample = preview ? preview.getAttribute('data-sample') || '' : '';

    function updateName() {
      if (!input || !preview) return;
      var v = input.value.trim(), text = v || sample, n = text.length;
      preview.textContent = text;
      preview.classList.toggle('is-sample', !v);
      preview.style.fontSize = n > 20 ? '1.4rem' : n > 14 ? '1.8rem' : n > 9 ? '2.3rem' : '3rem';
    }
    if (input) { input.addEventListener('input', updateName); updateName(); }

    function toggle(radiosSel, moreSel, textSel, triggerValue, onChange) {
      var radios = root.querySelectorAll(radiosSel), more = root.querySelector(moreSel), text = root.querySelector(textSel);
      function sync() {
        var sel = root.querySelector(radiosSel + ':checked');
        var show = sel && sel.value === triggerValue;
        if (more) more.hidden = !show;
        if (text) { text.required = !!show; if (!show) text.value = ''; }
        if (onChange) onChange(sel ? sel.value : '');
      }
      radios.forEach(function (r) { r.addEventListener('change', sync); });
      sync();
    }
    var wa = root.querySelector('[data-ll-wa]');
    if (wa) {
      try { var saved = window.localStorage.getItem('ll_wa'); if (saved && !wa.value) wa.value = saved; } catch (e) {}
      wa.addEventListener('change', function () { try { window.localStorage.setItem('ll_wa', wa.value.trim()); } catch (e) {} });
    }
    toggle('[data-ll-theme]', '[data-ll-theme-more]', '[data-ll-theme-text]', 'Something different');
    toggle('[data-ll-shape]', '[data-ll-shape-more]', '[data-ll-shape-text]', 'Something else', function (v) {
      if (badge) badge.setAttribute('data-shape', v === 'Something else' ? 'Circle' : v || 'Circle');
    });
  }
  function boot() { document.querySelectorAll('[data-ll-personaliser]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
